var $e9750b1ea6063c7a$exports = {};
$e9750b1ea6063c7a$exports = {
    "minimum": `Minimum`,
    "maximum": `Maximum`
};


export {$e9750b1ea6063c7a$exports as default};
//# sourceMappingURL=en-US.mjs.map
